<template>
    <div class="container-my-debits">
        <template>
            <div v-if="!this.$route.params.cpf" class="header-debits">
                <i
                    v-if="
                        parceiroConfig.sessoes.customization.campos.menuDebits
                            .flgPrefeituraMode
                    "
                    :style="{ parceiroConfigCorSecundariaCorPrimaria }"
                    class="fas fa-question"
                    @click="$router.push({ name: 'FAQ' })"
                ></i>

                <i
                    v-if="
                        parceiroConfig.sessoes.customization.campos.menuDebits
                            .flgPrefeituraMode
                    "
                    :style="{ parceiroConfigCorSecundariaCorPrimaria }"
                    class="fas fa-times"
                    @click="$router.push({ name: 'LandPageParceiro' })"
                ></i>

                <i
                    v-else
                    :style="{ parceiroConfigCorSecundariaCorPrimaria }"
                    class="fas fa-times"
                    @click="$router.push({ name: 'AccordionTabs' })"
                ></i>
            </div>

            <warning-card
                v-if="
                    parceiroConfig.sessoes.customization.campos.menuDebits
                        .flgPrefeituraMode
                "
                key="portal-prefeitura"
            ></warning-card>

            <div
                v-else
                key="portal-parceiro"
                style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                "
            >
                <h3 :style="{ parceiroConfigCorSecundariaCorPrimaria }">
                    {{ tituloMinhasDividas }}
                </h3>

                <p
                    v-if="parceiroConfig.identificador == 'Senff'"
                    id="paragrafo-senff"
                >
                    As ofertas são temporárias e podem ser ajustadas a qualquer
                    momento.
                </p>

                <p
                    v-if="dividas && dividas.length > 0"
                    key="portal-parceiro-com-dividas"
                    class="message-sub"
                >
                    {{ mensagemQuantidadeDeDividas }}
                </p>

                <p
                    v-else-if="
                        parceiroConfig.sessoes.customization.campos.landPage
                            .flgModoServico
                    "
                    key="portal-parceiro-sem-servicos"
                    class="message-sub"
                >
                    Você não possui nenhuma solução disponível
                </p>

                <div v-else-if="possuiAcordo">
                    <p class="message-sub">
                        Vimos que você já possui acordo, clique em MEUS ACORDOS
                        para verificar.
                    </p>

                    <button-default
                        text="MEUS ACORDOS"
                        @click.native="irParaPaginaDeAcordos"
                    ></button-default>
                </div>

                <p v-else key="portal-parceiro-sem-dividas" class="message-sub">
                    {{ mensagemVoceNaoTemDividas }}
                </p>

                <div
                    v-if="temPix"
                    style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    "
                >
                    <img
                        src="@/assets/images/pix-106.svg"
                        style="margin-bottom: 10px"
                    />
                    <p class="message-sub">Aceitamos pagamentos por PIX.</p>
                    <p class="message-sub">
                        Nossa chave PIX:
                        {{
                            parceiroConfig.sessoes.customization.campos.myDebits
                                .textChavePix
                        }}
                    </p>
                </div>

                <button-default
                    v-if="
                        linkSeguroSenff != '' &&
                        linkSeguroSenff != undefined &&
                        linkSeguroSenff != null
                    "
                    :color="parceiroConfigCorSecundariaCorPrimaria"
                    :secondaryColor="true"
                    :active="false"
                    @click.native="abrirLinkSeguroSenff()"
                    text="Dificuldades de pagamento? Seu seguro pode te ajudar. Clique e saiba mais"
                ></button-default>
            </div>

            <debit-card
                v-for="(divida, chave) in dividas"
                :key="chave"
                :divida="divida"
            ></debit-card>

            <transition name="chat-panel-transition">
                <section
                    v-if="mostrarChat && chatAberto"
                    id="chat-microcredito"
                    class="chat-panel"
                    aria-label="Atendimento por chat"
                >
                    <iframe
                        src="https://microcredito.beetsi.com/chat"
                        class="chat-panel__iframe"
                        title="Atendimento por chat"
                        allow="clipboard-write"
                    ></iframe>
                </section>
            </transition>

            <div v-if="mostrarChat" class="chat-fab-container">
                <div v-if="!chatAberto" class="chat-fab-tooltip">
                    Precisando de <strong>dinheiro</strong> para quitar suas
                    <strong>dívidas</strong>?
                </div>

                <button
                    type="button"
                    class="chat-button"
                    :aria-expanded="chatAberto.toString()"
                    aria-controls="chat-microcredito"
                    :aria-label="chatAberto ? 'Fechar chat' : 'Abrir chat'"
                    @click="alternarChat"
                >
                    <svg
                        v-if="chatAberto"
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                    >
                        <path
                            d="M6 6L18 18M18 6L6 18"
                            stroke="currentColor"
                            stroke-width="2.5"
                            stroke-linecap="round"
                        />
                    </svg>
                    <svg v-else viewBox="0 0 24 24" aria-hidden="true">
                        <path
                            d="M4 4h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8l-4 4V6c0-1.1.9-2 2-2z"
                        />
                    </svg>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations, createNamespacedHelpers } from "vuex";
import mixins from "@/mixins/mixins";

import DebitCard from "./components/DebitCard";
import Template from "@/views/admin/Template";
import WarningCard from "./components/WarningCard";
import ButtonDefault from "../../../components/buttons/ButtonDefault.vue";

const {
    mapActions: mapActionsPassosRetornarDividas,
    mapMutations: mapMutationsPassosRetornarDividas,
} = createNamespacedHelpers("passosRetornarDividas");

export default {
    name: "MyDebits",

    components: { Template, DebitCard, WarningCard, ButtonDefault },

    mixins: [mixins],

    data() {
        return {
            dividas: Array,
            qtdDividas: 0,
            possuiAcordo: false,
            arraySegundaVia: [],
            chatAberto: false,
        };
    },

    computed: {
        ...mapState({
            empresas: (estado) => estado.empresas,
            lojas: (estado) => estado.passosRetornarDividas.lojas,
            linkSeguroSenff: (estado) =>
                estado.passosRetornarDividas.linkSeguroSenff,
            pessoa: (estado) => estado.passosRetornarDividas.pessoa,
        }),

        mostrarChat() {
            return this.parceiroConfig.sessoes.customization.campos.myDebits.flgAtivarChatAcerteAqui;
        },

        tituloMinhasDividas() {
            return this.parceiroConfig.sessoes.customization.campos.myDebits
                .textMyDebits
                ? this.parceiroConfig.sessoes.customization.campos.myDebits
                      .textMyDebits
                : "Minhas Dívidas";
        },

        pluralOuSingular() {
            return this.parceiroConfig.sessoes.customization.campos.myDebits
                .subtextPanelMyDebits
                ? this.parceiroConfig.sessoes.customization.campos.myDebits
                      .subtextPanelMyDebits
                : this.qtdDividas === 1
                ? "dívida pendente"
                : "dívidas pendentes";
        },

        mensagemQuantidadeDeDividas() {
            if (
                typeof this.dividas === "object" &&
                Object.keys(this.dividas).length > 0
            ) {
                const dividas = Object.values(this.dividas);
                if (this.parceiroConfig.identificador == "Senff") {
                    dividas.forEach((divida) => {
                        Object.entries(divida.contratos).forEach(
                            ([key, contrato]) => {
                                this.qtdDividas += Object.values(
                                    contrato.parcelas
                                ).filter(
                                    (parcela) => parcela.lancamento_futuro == 0
                                ).length;
                            }
                        );
                    });
                } else {
                    dividas.forEach((divida) => {
                        Object.entries(divida.contratos).forEach(
                            ([key, contrato]) => {
                                this.qtdDividas += Object.keys(
                                    contrato.parcelas
                                ).length;
                            }
                        );
                    });
                }
            }

            return `Você possui ${this.qtdDividas} ${this.pluralOuSingular}`;
        },

        mensagemVoceNaoTemDividas() {
            return this.parceiroConfig.sessoes.customization.campos.myDebits
                .subtextPanelMyDebitsNotFound
                ? this.parceiroConfig.sessoes.customization.campos.myDebits
                      .subtextPanelMyDebitsNotFound
                : `Você não possui dívidas`;
        },

        temPix() {
            return (
                this.parceiroConfig.sessoes.customization.campos.myDebits
                    .textChavePix &&
                this.parceiroConfig.sessoes.customization.campos.myDebits
                    .textChavePix != "1"
            );
        },
    },

    created() {
        this.$nextTick(async function () {
            this.SET_LOADING(true);
            this.SET_LOADING_MESSAGE("Carregando suas dívidas.");

            if (this.$route.params.cpf) {
                let el = document.getElementsByClassName("box-lgpd")[0];
                if (el != undefined) el.style.display = "none";

                const botaoVoltar = document.querySelector("h6.button-back");
                if (botaoVoltar != undefined && botaoVoltar != null) {
                    botaoVoltar.style.display = "none";
                }

                if (
                    this.parceiroConfig.identificador == "Senff" &&
                    (this.$route.query.enumCanalOrigem == "" ||
                        this.$route.query.enumCanalOrigem == null ||
                        this.$route.query.enumCanalOrigem == undefined ||
                        this.$route.query.codAssessoriaSenff == "" ||
                        this.$route.query.codAssessoriaSenff == null ||
                        this.$route.query.codAssessoriaSenff == undefined)
                ) {
                    this.SET_LOADING(false);
                    this.SET_LOADING_MESSAGE("");

                    this.CHANGE_MESSAGE_MODAL({
                        show: true,
                        styleMessage: "danger",
                        title: "Erro",
                        message: "Parâmetros obrigatórios não informados",
                        mostrarBotaoEntendi: false,
                    });
                } else {
                    this.CHANGE_MESSAGE_MODAL({
                        show: false,
                        styleMessage: "danger",
                        title: "",
                        message: "",
                        mostrarBotaoEntendi: true,
                    });
                    await this.acaoRetornarTokenEmpresa();

                    const cpfSemPontuacao = this.removeMaskCharacters(
                        this.$route.params.cpf
                    );

                    this.SET_ENUM_CANAL_ORIGEM(
                        this.$route.query.enumCanalOrigem
                    );
                    this.SET_COD_ASSESSORIA_SENFF(
                        this.$route.query.codAssessoriaSenff
                    );

                    await this.acaoPasso1ConsultarCpf({
                        pesCpfCnpj: cpfSemPontuacao,
                    })
                        .then((resposta) => {
                            if (
                                !resposta.data?.dados ||
                                resposta.data.dados ===
                                    "CPF/CNPJ não encontrado!" ||
                                resposta.data.dados === null
                            ) {
                                this.SET_LOADING(false);
                                this.SET_LOADING_MESSAGE("");

                                this.CHANGE_MESSAGE_MODAL({
                                    show: true,
                                    title: "Usuario não encontrado",
                                    message: `Você não possui nenhuma dívida ou acordo cadastrado em nosso banco de dados.`,
                                    styleMessage: "danger",
                                });
                                return -1;
                            }
                        })
                        .catch((_) => {
                            this.SET_LOADING_MESSAGE("");
                            this.SET_LOADING(false);
                            this.CHANGE_MESSAGE_MODAL({
                                show: true,
                                title: "Erro",
                                message:
                                    "Não foi possível achar seu CPF em nossos registros!",
                                styleMessage: "danger",
                            });
                        });
                }
            }
            this.dividas = [];

            let lancamentoFuturo =
                this.parceiroConfig.identificador === "Senff" ? "S" : "N";
            if (this.lojas.length > 0) {
                this.lojas.forEach(async (loja) => {
                    if (loja.permite_negociar == "N") {
                        return;
                    }

                    if (
                        this.parceiroConfig.sessoes.customization.campos
                            .myDebits.flgPortalUsaStage
                    ) {
                        await this.acaoPasso2ConsultarDividasStage({
                            lojCodigo: loja.loj_codigo,
                        })
                            .then((resposta) => {
                                this.SET_TEM_SEGUNDA_VIA_SENFF(false);
                                if (resposta.parcelas.length == 0) {
                                    this.SET_LOADING(false);
                                    this.SET_LOADING_MESSAGE("");
                                    return;
                                }

                                const contratos = {};
                                let totalCorrigidoDividas = 0;
                                if (
                                    this.parceiroConfig.sessoes.customization
                                        .campos.myDebits.flgAgruparContratos
                                ) {
                                    resposta.parcelas.forEach((parcela) => {
                                        if (
                                            contratos[parcela.contrato] ==
                                            undefined
                                        ) {
                                            contratos[parcela.contrato] = {
                                                totalCorrigido: 0,
                                                parcelas: [],
                                            };
                                        }

                                        if (
                                            this.parceiroConfig.identificador ==
                                            "resolvatw"
                                        ) {
                                            contratos[parcela.contrato][
                                                "con_observacao2"
                                            ] =
                                                resposta.dados_contratos[
                                                    parcela.contrato
                                                ]["con_observacao2"];
                                            contratos[parcela.contrato][
                                                "con_observacao4"
                                            ] =
                                                resposta.dados_contratos[
                                                    parcela.contrato
                                                ]["con_observacao4"];
                                        }

                                        contratos[
                                            parcela.contrato
                                        ].parcelas.push({
                                            fase: parcela.diasAtraso,
                                            par_vencimento: this.formatarData(
                                                parcela.dataVencimento
                                            ),
                                            par_prestacao:
                                                parcela.numeroParcela,
                                            original: parcela.valorPrincipal,
                                            corrigido: parcela.valorAtual,
                                            pre_codigo: parcela.pre_codigo,
                                        });

                                        totalCorrigidoDividas +=
                                            Number.parseFloat(
                                                parcela.valorAtual
                                            );
                                    });

                                    this.dividas.push({
                                        contratos,
                                        loja,
                                        totalCorrigido: totalCorrigidoDividas,
                                    });
                                } else {
                                    resposta.parcelas.forEach((parcela) => {
                                        if (
                                            contratos[parcela.contrato] ==
                                            undefined
                                        ) {
                                            contratos[parcela.contrato] = {
                                                totalCorrigido: 0,
                                                parcelas: [],
                                            };
                                        }

                                        contratos[
                                            parcela.contrato
                                        ].parcelas.push({
                                            fase: parcela.diasAtraso,
                                            par_vencimento: this.formatarData(
                                                parcela.dataVencimento
                                            ),
                                            par_prestacao:
                                                parcela.numeroParcela,
                                            original: parcela.valorPrincipal,
                                            corrigido: parcela.valorAtual,
                                            pre_codigo: parcela.pre_codigo,
                                        });

                                        contratos[
                                            parcela.contrato
                                        ].totalCorrigido += Number.parseFloat(
                                            parcela.valorAtual
                                        );
                                    });

                                    Object.entries(contratos).forEach(
                                        ([chave, contrato]) => {
                                            let valorCorrigidoAPrazo = 0,
                                                valorCorrigido = 0;

                                            if (
                                                [
                                                    "resolvaloft",
                                                    "resolvaomni",
                                                    "resolvaomnidigital",
                                                ].includes(
                                                    this.parceiroConfig
                                                        .identificador
                                                )
                                            ) {
                                                Object.values(
                                                    contrato.parcelas
                                                ).forEach((parcela) => {
                                                    valorCorrigido +=
                                                        parcela.par_saldo;
                                                });
                                            } else {
                                                Object.values(
                                                    contrato.parcelas
                                                ).forEach((parcela) => {
                                                    valorCorrigido +=
                                                        parcela.corrigido;
                                                });
                                            }

                                            this.dividas.push({
                                                contratos: {
                                                    [chave]: contrato,
                                                },
                                                loja,
                                                totalCorrigido: valorCorrigido,

                                                contratos_avista: {
                                                    [chave]: contrato,
                                                },
                                                total_corrigido_avista:
                                                    valorCorrigido,

                                                contratos_aprazo: {
                                                    [chave]: contrato,
                                                },
                                                total_corrigido_aprazo:
                                                    valorCorrigidoAPrazo,

                                                integra_senff: "N",
                                                nome_loja_senff: "",
                                            });
                                        }
                                    );
                                }
                                this.SET_LOADING(false);
                                this.SET_LOADING_MESSAGE("");
                            })
                            .catch((_) => {
                                this.SET_LOADING(false);
                                this.SET_LOADING_MESSAGE("");
                                this.CHANGE_MESSAGE_MODAL({
                                    show: true,
                                    title: "Erro",
                                    message:
                                        "Erro ao carregar as sua dívidas, volte para o menu inicial!",
                                    styleMessage: "danger",
                                });
                            });
                    } else {
                        await this.acaoPasso2ConsultarDividas({
                            lojCodigo: loja.loj_codigo,
                            lancamentoFuturo: lancamentoFuturo,
                        })
                            .then((resposta) => {
                                if (resposta.retorno && resposta.dados) {
                                    this.SET_ARRAY_SEGUNDA_VIA_SENFF([]);
                                    this.SET_TEM_SEGUNDA_VIA_SENFF(false);
                                    if (
                                        resposta.dados.a_vista
                                            .loj_tipo_agrupamento_nagociacao ==
                                        "contratos_iguais"
                                    ) {
                                        let contratos =
                                            resposta.dados.a_vista.contratos;
                                        let contratos_aprazo =
                                            resposta.dados.a_prazo.contratos;

                                        Object.entries(contratos).forEach(
                                            ([chave, contrato]) => {
                                                let valorCorrigidoAPrazo = 0,
                                                    valorCorrigido = 0;

                                                if (
                                                    [
                                                        "resolvaloft",
                                                        "resolvaomni",
                                                        "resolvaomnidigital",
                                                    ].includes(
                                                        this.parceiroConfig
                                                            .identificador
                                                    )
                                                ) {
                                                    Object.values(
                                                        contrato.parcelas
                                                    ).forEach((parcela) => {
                                                        valorCorrigido +=
                                                            parcela.par_saldo;
                                                    });
                                                } else {
                                                    Object.values(
                                                        contrato.parcelas
                                                    ).forEach((parcela) => {
                                                        if (
                                                            parcela.pix_copia_cola_segunda_via !=
                                                            ""
                                                        ) {
                                                            this.ADD_ARRAY_SEGUNDA_VIA_SENFF(
                                                                {
                                                                    par_prestacao:
                                                                        parcela.par_prestacao,
                                                                    par_vencimento:
                                                                        parcela.par_vencimento,
                                                                    par_valor:
                                                                        parcela.par_valor,
                                                                    pix_copia_cola_segunda_via:
                                                                        parcela.pix_copia_cola_segunda_via,
                                                                    linha_digitavel_segunda_via:
                                                                        parcela.linha_digitavel_segunda_via,
                                                                    contrato:
                                                                        contrato.con_contrato,
                                                                }
                                                            );

                                                            this.SET_TEM_SEGUNDA_VIA_SENFF(
                                                                true
                                                            );
                                                        }

                                                        valorCorrigido +=
                                                            parcela.corrigido;
                                                    });
                                                }

                                                if (
                                                    contratos_aprazo !==
                                                    undefined
                                                ) {
                                                    Object.values(
                                                        contratos_aprazo[chave]
                                                            .parcelas
                                                    ).forEach((parcela) => {
                                                        valorCorrigidoAPrazo +=
                                                            parcela.corrigido;
                                                    });
                                                }

                                                this.dividas.push({
                                                    contratos: {
                                                        [chave]: contrato,
                                                    },
                                                    loja,
                                                    totalCorrigido:
                                                        valorCorrigido,

                                                    contratos_avista: {
                                                        [chave]: contrato,
                                                    },
                                                    total_corrigido_avista:
                                                        valorCorrigido,

                                                    contratos_aprazo: {
                                                        [chave]:
                                                            contratos_aprazo[
                                                                chave
                                                            ],
                                                    },
                                                    total_corrigido_aprazo:
                                                        valorCorrigidoAPrazo,

                                                    integra_senff:
                                                        resposta.dados.a_vista
                                                            .integra_senff,
                                                    nome_loja_senff:
                                                        contrato.con_nome_loja,
                                                });
                                            }
                                        );
                                    } else {
                                        let valorCorrigido = 0;
                                        if (
                                            [
                                                "resolvaloft",
                                                "resolvaomni",
                                                "resolvaomnidigital",
                                            ].includes(
                                                this.parceiroConfig
                                                    .identificador
                                            )
                                        ) {
                                            const contratos = Object.keys(
                                                resposta.dados.a_vista.contratos
                                            );
                                            Object.values(
                                                resposta.dados.a_vista.contratos
                                            ).forEach((contrato, posicao) => {
                                                contrato.origem =
                                                    contrato.con_observacao3;
                                                Object.values(
                                                    contrato.parcelas
                                                ).forEach((parcela) => {
                                                    if (
                                                        parcela.pix_copia_cola_segunda_via !=
                                                        ""
                                                    ) {
                                                        this.ADD_ARRAY_SEGUNDA_VIA_SENFF(
                                                            {
                                                                par_prestacao:
                                                                    parcela.par_prestacao,
                                                                par_vencimento:
                                                                    parcela.par_vencimento,
                                                                par_valor:
                                                                    parcela.par_valor,
                                                                pix_copia_cola_segunda_via:
                                                                    parcela.pix_copia_cola_segunda_via,
                                                                linha_digitavel_segunda_via:
                                                                    parcela.linha_digitavel_segunda_via,
                                                                contrato:
                                                                    contratos[
                                                                        posicao
                                                                    ],
                                                            }
                                                        );

                                                        this.SET_TEM_SEGUNDA_VIA_SENFF(
                                                            true
                                                        );
                                                    }

                                                    valorCorrigido +=
                                                        parcela.par_saldo;
                                                });
                                            });
                                        }

                                        this.dividas.push({
                                            contratos:
                                                resposta.dados.a_vista
                                                    .contratos,
                                            loja,
                                            totalCorrigido:
                                                valorCorrigido === 0
                                                    ? resposta.dados.a_vista
                                                          .total_corrigido
                                                    : valorCorrigido,

                                            tipo_necociacao:
                                                resposta.dados
                                                    .loj_tipo_agrupamento_nagociacao,
                                            contratos_aprazo:
                                                resposta.dados.a_prazo
                                                    .contratos,
                                            total_corrigido_aprazo:
                                                resposta.dados.a_prazo
                                                    .total_corrigido,
                                            contratos_avista:
                                                resposta.dados.a_vista
                                                    .contratos,
                                            total_corrigido_avista:
                                                resposta.dados.a_vista
                                                    .total_corrigido,
                                            desconto_total: resposta.dados.a_vista.desconto_total,
                                        });
                                    }
                                }

                                if (
                                    resposta.retorno === false &&
                                    resposta.mensagem == "Acordo Ativo"
                                ) {
                                    this.possuiAcordo = true;
                                }

                                this.SET_LOADING(false);
                                this.SET_LOADING_MESSAGE("");
                            })
                            .catch((_) => {
                                this.SET_LOADING(false);
                                this.SET_LOADING_MESSAGE("");
                                this.CHANGE_MESSAGE_MODAL({
                                    show: true,
                                    title: "Erro",
                                    message:
                                        "Erro ao carregar as sua dívidas, volte para o menu inicial!",
                                    styleMessage: "danger",
                                });
                            });
                    }
                });
            } else {
                this.SET_LOADING(false);
                this.SET_LOADING_MESSAGE("");
            }
        });
    },

    methods: {
        ...mapActions(["action_registrar_click_chat_acerte_aqui"]),

        ...mapActionsPassosRetornarDividas([
            "acaoRetornarTokenEmpresa",
            "acaoPasso1ConsultarCpf",
            "acaoPasso2ConsultarDividas",
            "acaoPasso2ConsultarDividasStage",
        ]),

        ...mapMutationsPassosRetornarDividas([
            "SET_TEM_SEGUNDA_VIA_SENFF",
            "ADD_ARRAY_SEGUNDA_VIA_SENFF",
            "SET_ARRAY_SEGUNDA_VIA_SENFF",
            "SET_ENUM_CANAL_ORIGEM",
            "SET_COD_ASSESSORIA_SENFF",
        ]),

        getSubdominio() {
            return window.location.host.split(".").length > 2;
        },

        formatarData(data) {
            if (data.indexOf("T") != -1) {
                data = data.substring(0, data.indexOf("T"));
            }

            let arrayData = data.split("-");
            let dia =
                arrayData[2].length == 2 ? arrayData[2] : `0${arrayData[2]}`;
            let mes =
                arrayData[1].length == 2 ? arrayData[1] : `0${arrayData[1]}`;
            return `${dia}/${mes}/${arrayData[0]}`;
        },

        alternarChat() {
            if (!this.chatAberto) {
                this.action_registrar_click_chat_acerte_aqui({
                    cpfCnpj: this.pessoa.pesCpfCnpj,
                    emp_codigo: this.parceiroConfig.emp_codigo,
                });
            }

            this.chatAberto = !this.chatAberto;
        },

        irParaPaginaDeAcordos() {
            this.SET_LOADING(true);
            this.SET_LOADING_MESSAGE("Carregando os seus acordos.");

            this.acaoSalvarEtapa({
                cpfCnpj: this.pessoa.pesCpfCnpj,
                esn_fk_ets_codigo: 3,
                emp_codigo: this.parceiroConfig.emp_codigo,
                motivo_agendamento: "Clicou no botão meus acordos na tela de dívidas",
                data_agendamento: this.dataAtual,
                hora_agendamento: this.horaAtual,
            });

            this.$router.push({
                name: "MyAgreements",
                params: { totemSenff: this.possuiAcordo ? "S" : "N" },
            });
        },

        abrirLinkSeguroSenff() {
            this.acaoSalvarEtapa({
                emp_codigo: this.parceiroConfig.emp_codigo,
                cpfCnpj: this.pessoa.pesCpfCnpj,
                esn_fk_ets_codigo: 104,
                data_agendamento: this.dataAtual,
                hora_agendamento: this.horaAtual,
                motivo_agendamento: "Abriu o link do seguro",
            });

            window.open(this.linkSeguroSenff, "_blank");
        },
    },
};
</script>

<style scoped>
.container-my-debits {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #f3f5f9;
    flex: 1;
    box-sizing: border-box;
}

.header-debits {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    box-sizing: border-box;
    width: 100%;
    max-width: 1024px;
    cursor: pointer;
}

h3 {
    color: var(--backgroundColor);
    font-family: Montserrat-Bold;
    font-size: 28px;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.header-debits i {
    font-size: 48px;
    margin: 10px 20px;
    color: var(--backgroundColor);
}

.message-sub {
    color: #5b6987;
    font-size: 14px;
    margin-bottom: 10px;
    text-align: justify;
}

#paragrafo-senff {
    color: var(--backgroundColor);
    font-size: 12px;
    margin-bottom: 10px;
}

.chat-fab-container {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 1001;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
}

.chat-fab-tooltip {
    position: relative;
    max-width: 230px;
    padding: 14px 18px;
    border: 1px solid #ffe9b8;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 8px 24px rgba(120, 80, 0, 0.16),
        0 2px 6px rgba(0, 0, 0, 0.06);
    color: #3a2c00;
    font-size: 14.5px;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 1.45;
    text-align: left;
    animation: float-tooltip 6s ease-in-out infinite;
}

.chat-fab-tooltip strong {
    color: #e56a00;
    font-weight: 700;
}

.chat-fab-tooltip::after {
    position: absolute;
    right: 22px;
    bottom: -8px;
    width: 16px;
    height: 16px;
    border-right: 1px solid #ffe9b8;
    border-bottom: 1px solid #ffe9b8;
    border-radius: 0 0 3px 0;
    background: #fff;
    content: "";
    transform: rotate(45deg);
}

.chat-button {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffbf00 0%, #ff7900 100%);
    color: #fff;
    box-shadow: 0 4px 12px rgba(229, 106, 0, 0.35);
    cursor: pointer;
    animation: chat-pulse 2s infinite;
    transition: filter 0.2s ease, transform 0.2s ease;
}

.chat-button:hover {
    filter: brightness(1.08);
    transform: scale(1.05);
}

.chat-button svg {
    width: 28px;
    height: 28px;
    fill: currentColor;
}

.chat-button:focus,
.chat-panel__close:focus {
    outline: 3px solid rgba(23, 105, 170, 0.35);
    outline-offset: 2px;
}

.chat-panel {
    position: fixed;
    right: 24px;
    bottom: 88px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    width: min(400px, calc(100vw - 32px));
    height: min(640px, calc(100vh - 120px));
    overflow: hidden;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.28);
    transform-origin: bottom right;
    will-change: opacity, transform;
}

.chat-panel-transition-enter-active,
.chat-panel-transition-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.chat-panel-transition-enter,
.chat-panel-transition-leave-to {
    opacity: 0;
    transform: translateY(15px) scale(0.97);
}

.chat-panel__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 52px;
    padding-left: 18px;
    background: var(--backgroundColor, #1769aa);
    color: #fff;
    font-family: Montserrat-Bold;
}

.chat-panel__close {
    align-self: stretch;
    width: 52px;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 20px;
}

.chat-panel__iframe {
    flex: 1;
    width: 100%;
    border: 0;
    background: #fff;
}

@media (max-width: 480px) {
    .chat-fab-container {
        right: 16px;
        bottom: 16px;
    }

    .chat-panel {
        right: 16px;
        bottom: 80px;
        height: calc(100vh - 96px);
    }

    .chat-panel-transition-enter,
    .chat-panel-transition-leave-to {
        transform: translateY(20px);
    }
}

@media (prefers-reduced-motion: reduce) {
    .chat-fab-tooltip,
    .chat-button,
    .chat-panel-transition-enter-active,
    .chat-panel-transition-leave-active {
        animation: none;
        transition: none;
    }
}

@keyframes float-tooltip {
    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-6px);
    }
}

@keyframes chat-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 121, 0, 0.55);
    }

    70% {
        box-shadow: 0 0 0 16px rgba(255, 121, 0, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 121, 0, 0);
    }
}
</style>
